__turbopack_context__.v({
  "cartDrawerTitleWrapper": "KBIklq_cartDrawerTitleWrapper",
  "cartDrawerTitleWrapperFullWidth": "KBIklq_cartDrawerTitleWrapperFullWidth",
  "title": "KBIklq_title",
  "titleWrapper": "KBIklq_titleWrapper",
  "wrapper": "KBIklq_wrapper",
  "wrapperColumn": "KBIklq_wrapperColumn",
  "wrapperHideRedirect": "KBIklq_wrapperHideRedirect",
});
